import { atom } from 'jotai';

export const shouldRepaintVenueMapAtom = atom<boolean>(false);

export const refreshShouldRepaintVenueMapAtom = atom(
  null,
  (_, set, value: boolean) => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        set(shouldRepaintVenueMapAtom, true);

        setTimeout(() => {
          set(shouldRepaintVenueMapAtom, false);
        }, 200);
      }, 50);
    });
  }
);
